import React, { ChangeEvent, useEffect, useState } from 'react';
import { Grid } from '@mui/system';
import { FORMS_TYPES } from 'common/types';
import CustomTextField from 'components/CustomTextField';
import { useFormValidation } from 'services/hooks/useFormValidation';
import { FinancialsFormProps, FormValueFinancials } from './FinancialsForm.props';

const constraints = {
  name: {
    presence: { allowEmpty: false, message: 'is required' },
    length: { minimum: 3, message: 'must be at least 3 characters' },
  },
};

const FinancialsForm = ({ initialValues = {}, onFormChange, tableTerms }: FinancialsFormProps) => {
  const { formValidated, validateForm } = useFormValidation(constraints);
  const [formValues, setFormValues] = useState<FormValueFinancials>(initialValues);
  const { errors } = formValidated;

  useEffect(() => {
    validateForm(formValues);
  }, [validateForm, formValues]);

  useEffect(() => {
    onFormChange(formValidated);
  }, [onFormChange, formValidated]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormValues(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Grid container>
      <CustomTextField
        required
        fullWidth
        id="name"
        name="name"
        type="text"
        label={`${tableTerms.tableName} name`}
        value={(formValues?.name as string) ?? ''}
        onChange={handleChange}
        formErrors={errors as FORMS_TYPES.FormFieldErrors}
      />
    </Grid>
  );
};

export default FinancialsForm;
